import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import 'vuetify/dist/vuetify.min.css'
import '@/assets/css/estilos.css'
import '@/assets/css/brand.css'
// Generado por Tailwind CLI (npm run tw:build). Migración Vue 2 → Vue 3.
import '@/assets/css/tailwind.gen.css'
// Componentes base del sistema nuevo (botones rm-btn, etc.)
import '@/assets/css/ui.css'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import EventBus from '@/plugins/event-bus'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.config.productionTip = false

Vue.use(EventBus, vuetify, VueSweetalert2)
new Vue({
  vuetify,
  router,
  render: h => h(App),
  created() {
    this.$vuetify.lang.current = 'es'
    const script = document.createElement('script')
    script.async = true
    document.body.appendChild(script)
  },
}).$mount('#app')

Vue.use(VueMoment, {
  moment,
})
Vue.directive('uppercase', {
  bind(el, _, vnode) {
    el.addEventListener('input', (e) => {
      e.target.value = e.target.value.toUpperCase()
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
    })
  }
})